/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceExecuteStandardRequest {
    getFixupPrototypeFunction() { return ComplianceExecuteStandardRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceExecuteStandardRequest>): ComplianceExecuteStandardRequest {
        let obj = Object.assign(new ComplianceExecuteStandardRequest(), model);
        ComplianceExecuteStandardRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceExecuteStandardRequest>): ComplianceExecuteStandardRequest {
        if (!model) return null;
        return ComplianceExecuteStandardRequest.newInstance(<ComplianceExecuteStandardRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceExecuteStandardRequest) {
        if (!obj) return;

        models.ComplianceExecuteStandardRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceExecuteStandardRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceExecuteStandardRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Mark existing in-progress assessment as complete prior to start of new assessment
     */
    mark_complete: boolean;

}
